export class EnumApiIdass {
    constructor() {
        /**
         * @dec 保存用户信息
         * @method put
         * @params
         */
        this.idass_update_userinfo = {
            url: '/api/gateway/idaas/v1/idaas/user/info/update',
            method: 'put',
        };
        /**
         * @dec 获取用户信息
         * @method get
         * @params
         */
        this.idass_get_userinfo = {
            url: '/api/gateway/idaas/v1/users/user/info/get',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec
         * @method get 获取文件上传凭证
         * @params
         */
        this.idass_get_file_code = {
            url: '/api/gateway/idaas/v1/file/authorization/code/get',
            method: 'get',
        };
        /**
         * @dec 切换登录身份
         */
        this.accountsvr_identity_switch = {
            url: '/api/gateway/idaas/v1/identity/switch',
            method: 'post',
        };
        /**
         * @dec
         * @method post 设置菜单是否收藏
         * @params
         */
        this.idass_get_menu_collect = {
            url: '/api/gateway/permission/user-identity/menu',
            method: 'post',
        };
        /**
         * @dec 身份转变，刷新token
         */
        this.accountsvr_refresh_indentity = {
            url: '/api/gateway/idaas/v1/identity/change/check',
            method: 'post',
        };
        /**
         * @dec 获取isg是否绑定微信
         */
        this.accountsvr_isg_isbind_wechat = {
            url: '/api/gateway/idaas/v1/wechat/isg/user/get',
            method: 'get',
        };
    }
}
